import {rpAppLink} from "@pg-mono/rp-routes";

const configuratorImg = require("../images/baner_konf_desktop.jpg");
const configuratorImgMobile = require("../images/baner_konf_mobile.jpg");
const spainBannerImg = require("../images/baner_spain_desktop.jpg");
const spainBannerImgMobile = require("../images/baner_spain_mobile.jpg");

export const INTERNAL_BANNERS = [
    {
        img: configuratorImg,
        mobileImg: configuratorImgMobile,
        link: rpAppLink.propertyConfigurator()
    },
    {
        img: spainBannerImg,
        mobileImg: spainBannerImgMobile,
        link: rpAppLink.investmentOffer.investmentCategory.subcategory.base({category: "za-granica", subcategory: "hiszpania"})
    }
];
